import { render } from "./ClientModal.vue?vue&type=template&id=27d727c4&scoped=true"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"

import "./ClientModal.vue?vue&type=style&index=0&id=27d727c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d727c4"]])

export default __exports__